/**
 * Picks specific keys from an object and creates a new object
 *
 * @param obj {Obj} - object to be parsed
 * @param keyList {string[]} - list of keys to be processed
 * @returns parsedObj {Obj} - processed object
 */
export function pick (obj, keyList = []) {
  const result = {};

  if (!obj) {
    return result;
  }

  for (const key of keyList) {
    result[key] = obj[key];
  }

  return result;
}

/**
 * Creates a new object which omits specific keys from the source object
 *
 * @param obj {Obj} - object to be parsed
 * @param keyList {string[]} - list of keys to be processed
 * @returns parsedObj {Obj} - processed object
 */
export function omit (obj, keyList = []) {
  const result = {};

  if (!obj) {
    return result;
  }

  for (const key in obj) {
    if (!keyList.includes(key)) {
      result[key] = obj[key];
    }
  }

  return result;
}
